import { Routes } from "@angular/router";
import { BlotterEffects, blotterFeature } from "@features/blotter";
import { provideEffects } from "@ngrx/effects";
import { provideState } from "@ngrx/store";

export const tradeCostAnalysisRoutes: Routes = [
	{
		path: "trade-analyser-pro",
		title: "Trade Analyser Pro | Tenora",
		providers: [provideEffects(BlotterEffects), provideState(blotterFeature)],
		loadComponent: () =>
			import("../components/views/pages/trade-cost-analysis-page/trade-cost-analysis-page.component").then(
				(component) => component.TradeCostAnalysisPageComponent
			),
		data: {
			pageTitle: "Trade Analyser Pro",
			tooltip: "This tool analyses your trades"
		}
	}
];
